import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=9599619c&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=9599619c&prod&lang=css&"
import style1 from "./Detail.vue?vue&type=style&index=1&id=9599619c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9599619c",
  null
  
)

export default component.exports